export const otaRefundGerman = {
  title: 'Dokumentierte Erstattungen · {{channel}}',
  missing:
    'Für diese Buchung ist noch keine Finanzgrundlage verfügbar. Der Stand muss geprüft werden.',
  conflict: 'Die Finanzgrundlage stimmt nicht mit der Buchung überein und muss geprüft werden.',
  stale: 'Angezeigt ist der zuletzt geladene Stand.',
  empty: 'Keine dokumentierten Erstattungen.',
};

export const otaRefundEnglish = {
  title: 'Documented refunds · {{channel}}',
  missing: 'The financial basis for this booking is not available yet. It needs to be reviewed.',
  conflict: 'The financial basis does not match the booking and needs to be reviewed.',
  stale: 'Showing the last loaded data.',
  empty: 'No documented refunds.',
};
